import React from "react";
import CategoryProductList from "./CategoryProductList";

const EngineOilParts = () => {
  return (
    <CategoryProductList
      categoryName="Engine Oil"
      categorySlug="engine_oil"
    />
  );
};

export default EngineOilParts;
